import { faLoader } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import {
  faCheckCircle,
  faCircleXmark,
  faExclamationTriangle,
  faFlag,
} from '@fortawesome/free-solid-svg-icons';

import type { InfoBannerVariant } from './InfoBanner';

// Get variant styles for InfoBanner component
export const getVariantStyles = (variant: InfoBannerVariant) => {
  switch (variant) {
    case 'warning':
      return {
        cardClass: '!vai-bg-amber-50 vai-border-amber-100',
        closeButtonClass: 'vai-text-amber-600 hover:vai-bg-amber-100',
        iconClass: 'vai-text-amber-600',
        titleClass: 'vai-text-amber-600',
        icon: faExclamationTriangle,
      };
    case 'error':
      return {
        cardClass: '!vai-bg-red-50 vai-border-red-100',
        closeButtonClass: 'vai-text-red-600 hover:vai-bg-red-100',
        iconClass: 'vai-text-red-600',
        titleClass: 'vai-text-red-600',
        icon: faCircleXmark,
      };
    case 'success':
      return {
        cardClass: '!vai-bg-green-50 vai-border-green-100',
        closeButtonClass: 'vai-text-green-600 hover:vai-bg-green-100',
        iconClass: 'vai-text-green-600',
        titleClass: 'vai-text-green-600',
        icon: faCheckCircle,
      };
    case 'progress':
      return {
        cardClass: '!vai-bg-blue-50 vai-border-blue-200',
        closeButtonClass: 'vai-text-blue-600 hover:vai-bg-blue-100',
        iconClass: 'vai-text-sapphire-600',
        titleClass: 'vai-text-sapphire-600',
        icon: faLoader,
      };
    case 'primary':
      return {
        cardClass: '!vai-bg-blue-50 vai-border-blue-200',
        closeButtonClass: 'vai-text-blue-600 hover:vai-bg-blue-100',
        iconClass: 'vai-text-sapphire-600',
        titleClass: 'vai-text-sapphire-600',
        icon: faFlag,
      };
    default: // 'default' - grey variant
      return {
        cardClass: '!vai-bg-zinc-100 vai-border-zinc-300',
        closeButtonClass: 'vai-text-gray-600 hover:vai-bg-gray-100',
        iconClass: 'vai-text-gray-600',
        titleClass: 'vai-text-gray-600',
        icon: faFlag,
      };
  }
};
